module.exports = __webpack_public_path__ + "static/media/dashboard.6d387c5a.svg";